import React, { Component } from "react";
import "../../Assets/css/myaccount.css";
import {
  Breadcrumbs,
  CircularProgress,
  Link,
  Typography,
} from "@material-ui/core";
import { Skeleton } from "@mui/material";
import { Col, Container, Image, Row } from "react-bootstrap";
import { SideBySideMagnifier } from "react-image-magnifiers";
import ImageGallery from "react-image-gallery";
import "../../Assets/css/productDetails.css";
import "../../../node_modules/react-image-gallery/styles/css/image-gallery.css";
import { Button } from "@mui/material";
import axios from "axios";
import {
  base_url,
  client_name,
  currency,
  currencycode,
  isLogin,
  postHeader,
  setSteps,
  user,
} from "../../Helpers/request";
import { toast } from "react-toastify";
import Videoimg from "../../Assets/images/example-360video-thumb.jpg";
import moment from "moment";
import {
  FacebookShareButton,
  EmailShareButton,
  PinterestShareButton,
  TwitterShareButton,
} from "react-share";
import { Helmet } from "react-helmet";
import Ringbildermenu from "../../Components/ringbildermenu";
import {
  ProductAppoitnment,
  ProductEnquiry,
  ReturnModal,
  ShippingModal,
} from "../../Components/Modals";
import { isMobileOnly, isTablet } from "react-device-detect";
import { NavLink, Redirect } from "react-router-dom";
import giaLogo from "../../Assets/images/lab-gia.png";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { store } from "../../Store/store";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import { sessionId } from "../../Reducer/homeReducer";
import authorisedImg from "../../Assets/images/alicias-img/authorised-img.png";
import WarrantyImg from "../../Assets/images/alicias-img/2-year-warranty.jpg";
import { FaCheckCircle } from "react-icons/fa";

class WatchDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilter: true,
      images: [],
      currentImageUrl: [],
      currentImagetype: null,
      currencies: [
        {
          value: "Round",
          label: "Round",
        },
        {
          value: "Round Cut",
          label: "Round Cut",
        },
        {
          value: "Round1",
          label: "Round1",
        },
        {
          value: "Round2",
          label: "Round2",
        },
      ],
      currency: false,
      value: "5",
      shipping: false,
      appointment: false,
      return: false,
      review: false,
      productdetails: [],
      reviewdata: [],
      stock_no: decodeURIComponent(this.props.match.params.stock_no),
      rating: "",
      comment: "",
      ringSize: 0,
      notify: false,
      ringSizeAvailable: false,
      loader: true,
      date: moment(new Date()).format("YYYY-MM-DD"),
      time: true,
      shippingterm: [],
      redirection: false,
      isExpanded: false,
    };
  }
  componentDidMount() {
    setSteps(1);
    this.productdetails();
    this.shippingterm();
  }

  toggleContent = () => {
    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded, // Toggle the isExpanded state
    }));
  };
  shippingterm = () => {
    axios
      .get(base_url + "/order/shipping_options", {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          this.setState({ shippingterm: res.data.data });
        } else {
          toast.error(res.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  productdetails = () => {
    this.setState({ loader: true });
    const data = {
      currency_code: currencycode,
      stock_no: this.state.stock_no,
      user_id: user.user_id ? user.user_id : "",
      token: user?.token,
      session_id: store.getState().persistedReducer.home.session_id,
    };
    axios
      .post(base_url + "/watch/watch_detail", data, {
        headers: postHeader,
      })
      .then(async (res) => {
        if (res.data.status == 1) {
          var arr = [];
          this.setState({
            productdetails: res.data.data,
            currentImageUrl: res.data.data?.imagelink[0]?.url,
            currentImagetype: 1,
          });

          await res.data.data?.imagelink.forEach((img) => {
            let obj = {
              original: img?.url,
              thumbnail: img?.url,
              originalAlt: res.data.data?.name,
              thumbnailAlt: res.data.data?.name,
              type: 1,
            };
            arr.push(obj);
          });

          if (res.data.data?.videolink != null) {
            var obj = {
              original: res.data.data?.videolink,
              thumbnail: Videoimg,
              originalAlt: res.data.data?.name,
              thumbnailAlt: res.data.data?.name,
              type: 2,
            };
            arr.push(obj);
          }
          if (res.data.data?.video_html != null) {
            var obj = {
              original: res.data.data?.video_html,
              thumbnail: Videoimg,
              originalAlt: res.data.data?.name,
              thumbnailAlt: res.data.data?.name,
              type: 3,
            };
            arr.push(obj);
          }
          this.setState({ images: arr, loader: false });
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          store.dispatch(whishlistlength(0));
          store.dispatch(cartlengthvalue(0));
          store.dispatch(sessionId(""));
          this.props.history.push("/");
          window.location.reload(true);
        } else if (res.data.status == 0) {
          // this.setState({
          //   redirection: true,
          // });
        } else {
          //this.props.history.push("/page-not-found");
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  addtowishlist = (product_id) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: store.getState().persistedReducer.home.session_id,
      product_id: product_id,
      type: "watch",
      token: isLogin ? user.token : "",
    };
    axios
      .post(base_url + "/order/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          this.productdetails();
          store.dispatch(whishlistlength(res.data.data.count));
          toast.success(res.message, { autoClose: 3000 });
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          store.dispatch(whishlistlength(0));
          store.dispatch(cartlengthvalue(0));
          store.dispatch(sessionId(""));
          this.props.history.push("/");
          window.location.reload(true);
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onchangeselect = (e, title) => {
    var changedata = [...this.state.filterdata];
    changedata = changedata.map((obj) =>
      obj.title == title
        ? Object.assign(obj, { selected: e.target.value })
        : obj
    );
    this.setState({ filterdata: changedata });
    this.productdetails();
  };
  getReview = (product_id) => {
    const data = {
      currency_code: currencycode,
      product_id: product_id,
    };
    axios
      .post(base_url + "/product/reviews_list", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          this.setState({ reviewdata: response.data.data });
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  submitReview = () => {
    const data = {
      currency_code: currencycode,
      user_id: user?.user_id,
      token: user?.token,
      rating: this.state.rating,
      review: this.state.comment,
      product_id: this.state.productdetails?.product_id,
    };
    axios
      .post(base_url + "/product/add_review", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          this.getReview(data.product_id);

          this.setState({ review: false });
        } else if (response.data.status == 2) {
          localStorage.removeItem("bw-user");
          store.dispatch(whishlistlength(0));
          store.dispatch(cartlengthvalue(0));
          store.dispatch(sessionId(""));
          this.props.history.push("/");
          window.location.reload(true);
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleShowInquiry = () => this.setState({ inquiry: true });
  handleCloseInquiry = () => this.setState({ inquiry: false });
  handleCloseShipping = () => this.setState({ shipping: false });
  handleShowShipping = () => this.setState({ shipping: true });
  handleShowAppointment = () => this.setState({ appointment: true });
  handleCloseAppointment = () => this.setState({ appointment: false });
  handleCloseReturn = () => this.setState({ return: false });
  handleShowReturn = () => this.setState({ return: true });
  handleCloseReview = () => this.setState({ review: false });
  handleShowReview = () => this.setState({ review: true });

  setView = (event, index) => {
    this.setState({
      currentImageUrl: this.state.images[index].original,
      currentImagetype: this.state.images[index].type,
    });
  };

  addtocart = (val) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: store.getState().persistedReducer.home.session_id,
      product_id: val,
      quantity: "1",
      token: isLogin ? user.token : "",
      type: "watch",
    };

    axios
      .post(base_url + "/order/add_to_cart", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          store.dispatch(cartlengthvalue(res.data.data.total_count));
          this.props.history.push("/cart");
          localStorage.removeItem("bw-gemstonedata");
          localStorage.removeItem("bw-diamonddata");
          localStorage.removeItem("bw-settingdata");
          localStorage.removeItem("bw-fancycolordata");
          sessionStorage.removeItem("bw_d_filter");
          sessionStorage.removeItem("bw_s_filter");
          sessionStorage.removeItem("bw_g_filter");
          sessionStorage.removeItem("bw_f_filter");
          toast.success(res.data.message, { autoClose: 3000 });
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          store.dispatch(whishlistlength(0));
          store.dispatch(cartlengthvalue(0));
          store.dispatch(sessionId(""));
          // this.props.history.push("/");
          // window.location.reload(true);
        } else {
          toast.error(res.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const images = this.state.images; // Replace this with your image data

    const gallerySettings = {
      items: images,
      showFullscreenButton: false,
      showPlayButton: true,
      showNav: true,
      thumbnailPosition: "custom",
      lazyLoad: true,
      disableThumbnailScroll: true,
      infinite: false, // Lazy load images for performance
    };

    let shortDescription = this.state.productdetails?.description?.slice(
      0,
      810
    );
    var average = 0;
    const average1 = this.state.reviewdata?.rating_count?.map((val) =>
      val.rating == 5 ? (average = val.average) : ""
    );
    return (
      <>
        {console.log("stock_no", this.state.stock_no)}
        {this.state.redirection && <Redirect to="/404" />}
        <Helmet>
          <meta charSet="utf-8" />
          <title>{this.state.productdetails.name}</title>
          <meta
            name="description"
            content={this.state.productdetails?.description}
          ></meta>
          <meta name="keywords" content=""></meta>
        </Helmet>
        {this.state.loader ? (
          <div className="rcs_filter_wrapper">
            <CircularProgress className="rcs_filter_loader" />
          </div>
        ) : (
          ""
        )}
        <div className="rcs_ringsetting_section mt-3">
          <Container className="rcs_shap-wizard_container">
            <Row>
              <Col className="rcs_breadcrumb mb-2">
                <Breadcrumbs aria-label="breadcrumb">
                  <NavLink underline="hover" color="inherit" to="/">
                    Home
                  </NavLink>
                  <NavLink underline="hover" color="inherit" to="/watches">
                    Watches
                  </NavLink>
                  <Typography color="text.primary">
                    {this.state.productdetails?.name}
                  </Typography>
                </Breadcrumbs>
              </Col>
            </Row>
          </Container>
        </div>
        {/* <Container className="rcs_shap-wizard_container">
                    <Ringbildermenu location="diamond" />
                </Container> */}
        <div className="rcs_product_details">
          <Container>
            <Row className="align-items-start">
              <Col sm={12} md={12} lg={8} xl={8} className="rcs_large_tablet">
                <div className="magnify-Image">
                  <Row className="">
                    <Col sm={2} className="order-last order-sm-first">
                      <ImageGallery
                        {...gallerySettings}
                        items={this.state.images}
                        onThumbnailClick={this.setView}
                        showFullscreenButton={false}
                        showPlayButton={false}
                        showNav={false}
                      />
                      {/* {this.state.videos?.map((val,index) => 
                                            <button onClick={(e)=> this.setViewvideo(e,index)} type="button" className= {this.state.currentImagetype == 1 ? "image-gallery-thumbnail " : "image-gallery-thumbnail active"}>
                                                <span class="image-gallery-thumbnail-inner">
                                                    <video class="image-gallery-thumbnail-image" src={Videoimg} />
                                                        </span>
                                                        </button> 
                                            )} */}
                    </Col>
                    <Col sm={10}>
                      {this.state.currentImagetype == 1 ? (
                        <SideBySideMagnifier
                          alwaysInPlace={false}
                          className="image-to-magnify watchDetailSl"
                          fillAvailableSpace={false}
                          imageSrc={this.state.currentImageUrl}
                          largeImageSrc={this.state.currentImageUrl}
                        />
                      ) : (
                        <div className="video-wrapper">
                          {this.state.currentImagetype == 2 ? (
                            <video
                              width="540"
                              height="540"
                              src={this.state.currentImageUrl}
                              frameBorder="0"
                              allowFullScreen
                              playsinline="true"
                              autoPlay="true"
                              loop
                            ></video>
                          ) : (
                            <iframe title="video"
                              src={this.state.currentImageUrl}
                              style={{ width: 540, height: 570 }}
                            ></iframe>
                          )}
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col sm={12} md={12} lg={4} xl={4} className="rcs_large_tablet">
                <div className="ml_product_content d-flex widget flex-column justify-content-center align-items-start text-left pt-3 pt-md-0 w-100 widget h-100">
                  {this.state.loader ? (
                    <div className="rcs_content_block w-100">
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={290}
                          height={45}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={500}
                          height={45}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={350}
                          height={45}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={100}
                          height={30}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={150}
                          height={30}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={100}
                          height={30}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={150}
                          height={30}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={210}
                          height={30}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={150}
                          height={30}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={40}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={690}
                          height={40}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={50}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={40}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={690}
                          height={40}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={50}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={40}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={690}
                          height={40}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={50}
                        />
                      )}
                      {/* <div className="rcs_product_btn">
                                                <ul className='d-flex justify-content-between'>
                                                    <li>{isMobileOnly ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={135} height={35} /> : isTablet ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={340} height={40} /> : <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={165} height={35} />}</li>
                                                    <li>{isMobileOnly ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={135} height={35} /> : isTablet ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={340} height={40} /> : <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px', marginBottom: '5px' }} width={165} height={35} />}</li>
                                                </ul>
                                            </div> */}
                      <div className="rcs_social">
                        <ul>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <div className="rcs_content_block w-100">
                      {this.state.productdetails?.brand && (
                        <p style={{ color: "#6d6d6d" }} className="mb-1">
                          {this.state.productdetails?.brand}
                        </p>
                      )}
                      <div className="rcs_product_heading">
                        <h1 className="fw600" style={{ color: "#000" }}>
                          {this.state.productdetails?.name}
                        </h1>
                      </div>
                      {this.state.productdetails?.stock_no &&
                        this.state.productdetails?.brand === "BULOVA" && (
                          <div class="rcs_price">
                            <p>
                              <strong>SKU :</strong>{" "}
                              {this.state.productdetails?.stock_no}
                            </p>
                          </div>
                        )}
                      {this.state.productdetails.is_price == 1 ? (
                        <div className="rcs_price">
                          <p className="fw600 fs18" style={{ color: "#000" }}>
                            {" "}
                            MSRP&nbsp;
                            {currency}
                            {this.state.productdetails?.sale_price}
                          </p>
                        </div>
                      ) : (
                        <div className="rcs_email">
                          <span>Email us for Price</span>
                        </div>
                      )}
                      {/* <div className="rcs_price">
                                                <p><span>{this.state.productdetails?.color} Color </span>|<span> {this.state.productdetails?.clarity} Clarity</span></p>
                                            </div> */}
                      <div className="rcs_product_btn">
                        {this.state.productdetails?.enable_ecommerce == 1 ? (
                          this.state.productdetails?.is_cart ? (
                            <Button aria-label="Already in Cart"
                              variant="contained"
                              disabled
                              className="rcs_acc_button rcs_acc_button1 w-100 mb-3"
                            >
                              Already in Cart
                            </Button>
                          ) : (
                            // <Button
                            //   variant="contained"
                            //   onClick={() =>
                            //     this.addtocart(
                            //       this.state.productdetails?.stock_no
                            //     )
                            //   }
                            //   className="rcs_acc_button rcs_acc_button1 w-100 mb-3"
                            // >
                            //   Add to Cart
                            // </Button>
                            <Button aria-label="Inquire for Availability"
                              variant="contained"
                              className="rcs_acc_button rcs_acc_button1 w-100 mb-3"
                              onClick={() => this.handleShowInquiry()}
                            >
                              Inquire for Availability
                            </Button>
                          )
                        ) : (
                          <Button aria-label="Inquiry"
                            variant="contained"
                            className="rcs_acc_button rcs_acc_button1 w-100 mb-3"
                            onClick={() => this.handleShowInquiry()}
                          >
                            Inquiry
                          </Button>
                        )}

                        {this.state.productdetails?.is_cart ||
                        JSON.parse(localStorage.getItem("bw-diamonddata")) ? (
                          this.state.productdetails?.is_wishlist == 0 ? (
                            <Button aria-label="Add to Wish List"
                              variant="outlined"
                              onClick={() =>
                                this.addtowishlist(
                                  this.state.productdetails?.stock_no
                                )
                              }
                              className="rcs_border_btn w-100 mb-3"
                            >
                              Add to Wish List
                            </Button>
                          ) : (
                            <Button aria-label="Remove Wish List"
                              onClick={() =>
                                this.addtowishlist(
                                  this.state.productdetails?.stock_no
                                )
                              }
                              variant="outlined"
                              className="rcs_border_btn w-100 mb-3"
                            >
                              Remove Wish List
                            </Button>
                          )
                        ) : (
                          <ul>
                            <li>
                              {this.state.productdetails?.is_wishlist == 0 ? (
                                <Button aria-label="Add to Wish List"
                                  variant="outlined"
                                  onClick={() =>
                                    this.addtowishlist(
                                      this.state.productdetails?.stock_no
                                    )
                                  }
                                  className="rcs_border_btn rcs_border_btn1 mb-3 float-left mr-1 w-100"
                                >
                                  Add to Wish List
                                </Button>
                              ) : (
                                <Button aria-label="Remove Wish List"
                                  onClick={() =>
                                    this.addtowishlist(
                                      this.state.productdetails?.stock_no
                                    )
                                  }
                                  variant="outlined"
                                  className="rcs_border_btn rcs_border_btn1 mb-3 float-left mr-1 w-100"
                                >
                                  Remove Wish List
                                </Button>
                              )}
                            </li>
                            <li>
                              {" "}
                              <Button aria-label="Schedule an Appointment"
                                variant="outlined"
                                className="rcs_border_btn w-100 mb-3"
                                onClick={this.handleShowAppointment}
                              >
                                Schedule an Appointment
                              </Button>
                            </li>
                          </ul>
                        )}

                        {/* <ul>
                                                    <li><Button variant="outlined" className="rcs_border_btn rcs_border_btn1 mb-3 float-left mr-1 rcs_border_btn_border" onClick={this.handleShowShipping}> <i class="fas fa-shipping-fast"></i> Shipping</Button></li>
                                                    <li><Button variant="outlined" className="rcs_border_btn rcs_border_btn1 mb-3 ml-1 rcs_border_btn_border" onClick={this.handleShowReturn}> <i class="fas fa-undo-alt"></i> Returns</Button></li>
                                                </ul> */}
                      </div>
                      <div className="rcs_social">
                        <ul>
                          <li>
                            <FacebookShareButton
                              url={String(window.location)}
                              className="Demo__some-network__share-button"
                            >
                              <i class="fab fa-facebook-f"></i> Facebook
                            </FacebookShareButton>
                          </li>
                          <li>
                            <PinterestShareButton
                              url={String(window.location)}
                              media={String(window.location)}
                              windowWidth={1000}
                              windowHeight={730}
                            >
                              <i class="fab fa-pinterest-p"></i> Pinterest
                            </PinterestShareButton>{" "}
                          </li>
                          <li>
                            <EmailShareButton
                              subject={client_name.c_name}
                              body={String(window.location)}
                            >
                              <i class="fas fa-envelope"></i> Email
                            </EmailShareButton>{" "}
                          </li>
                          <li>
                            <TwitterShareButton
                              title={client_name.c_name}
                              url={String(window.location)}
                            >
                              <i class="fab fa-twitter"></i> Twitter
                            </TwitterShareButton>{" "}
                          </li>
                        </ul>
                      </div>
                      {this.state.productdetails?.certificatelink?.length ? (
                        <div className="rcs_gia_reports">
                          <a
                            href={this.state.productdetails?.certificatelink}
                            className="rcs_border_btn w-100 mt-3"
                            target="_blank"
                          >
                            <Image
                              src={this.state.productdetails?.certificatelogo}
                              alt="GIA report"
                            ></Image>
                            View Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="ali_autorised_logo">
                        {/* <div className="tag">
                            <FaCheckCircle className="tag-icon" />
                            <span>2 Years Warranty</span>
                          </div> */}

                        <Image src={WarrantyImg} alt="Warranty logo" />
                        <Image src={authorisedImg} alt="Autorised logo" />
                      </div>
                      {this.state.productdetails?.key_description && (
                        <div className="w-100">
                          <h5>Key Features</h5>
                          <p>{this.state.productdetails?.key_description}</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="rcs_product_specification">
          <Container>
            <Row className="m-auto w-100">
              <Col md={4} className="p-0">
                <div className="pr-3">
                  <h2 className="fw600 pt-0">WATCH DETAILS</h2>
                  <p
                    className="mb-2"
                    dangerouslySetInnerHTML={{
                      __html: this.state.isExpanded
                        ? this.state.productdetails.description
                        : shortDescription +
                          (this.state.productdetails?.description?.length > 710
                            ? "..."
                            : ""),
                    }}
                  ></p>
                  {/* <p className="mb-2">{this.state.isExpanded ? this.state.productdetails.description : shortDescription+(this.state.productdetails?.description?.length > 810 ? "..." : "")}</p> */}
                  {this.state.productdetails?.description?.length > 710 && (
                    <button className="showMore" onClick={this.toggleContent} aria-label="Show More">
                      {this.state.isExpanded ? "Show Less" : "Show More"}
                    </button>
                  )}
                </div>
              </Col>
              <Col md={8}>
                <Row>
                  {this.state.productdetails?.attribute?.map(
                    (e, i) =>
                      e?.value && (
                        <Col xs={6} sm={4} key={i}>
                          <div className="rcs_product_specification_content">
                            <strong>{e?.title}: </strong>
                            <p>{e?.value}</p>
                          </div>
                        </Col>
                      )
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </div>

        {/*Shipping Modal*/}
        {this.state.shipping ? (
          <ShippingModal
            shippingterm={this.state.shippingterm}
            handleCloseShipping={this.handleCloseShipping}
          />
        ) : (
          ""
        )}
        {/*Shipping Modal*/}
        {/*Inquiry Modal*/}
        {this.state.inquiry ? (
          <ProductEnquiry
            productid={this.state.productdetails?.product_id}
            handleCloseInquiry={this.handleCloseInquiry}
          />
        ) : (
          ""
        )}
        {/*Inquiry Modal*/}
        {/*Appointment Modal*/}
        {this.state.appointment ? (
          <ProductAppoitnment
            type="watch"
            id={this.state.productdetails?.stock_no}
            handleClose={() => this.setState({ appointment: false })}
          />
        ) : (
          ""
        )}
        {/*Appointment Modal*/}
        {/*Return Modal*/}
        {this.state.return ? (
          <ReturnModal handleCloseReturn={this.handleCloseReturn} />
        ) : (
          ""
        )}
        {/*Return Modal*/}
      </>
    );
  }
}

export default WatchDetails;
